import {Component, Input, ViewEncapsulation} from '@angular/core';
import {OrderSummaryComponent} from '@spartacus/cart/base/components';

@Component({
    selector: 'app-uig-order-summary',
    templateUrl: './uig-order-summary.component.html',
    styleUrls: ['./uig-order-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigOrderSummaryComponent extends OrderSummaryComponent {

  @Input() shortVersion: boolean = false;

}
